import { Translatable } from "@icc/shared/helpers";

/** Bok skrzynki */
export class RollerBlindSide {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Kod do wydruków */
    printCode: string;
    description: string;
    weight: number;
    /** Kolejność */
    order: number;
    colorGroupSetId: number | null;
    blindBoxesIds: number[];
    /* Możliwość wyboru koloru w konfiguratorze */
    colorChoiceInConfigurator: boolean;
    /* Ograniczaj kolory boczków według "Dostępności kolorów boczków skrzynki" */
    limitColorsByBlindSideColorsAvailability: boolean;
}

export interface BlindSideColorsAvailability {
    id: number;
    boxColorId: number;
    blindSideColorIds: number[];
}
